import type { DesignFlow } from '../types/designFlow';

const designFlows: Record<string, DesignFlow> = {
  generate: {
    value: 'generate',
    label: 'messages.designWithStunnr',
    description: 'messages.aiPoweredBanners',
    stepperActionLabel: 'messages.generate'
  },
  upload: {
    value: 'upload',
    label: 'messages.uploadACreative',
    description: 'messages.checkYourAsset',
    stepperActionLabel: 'messages.validate'
  },
  convert: {
    value: 'convert',
    label: 'messages.convert',
    description: 'messages.bringAnyBanner',
    stepperActionLabel: 'messages.convert'
  },
};

export default designFlows;
